<div [class.content-body]="!embedded">
  <app-breadcrumb *ngIf="!embedded" [breadcrumb]="breadcrumbList"></app-breadcrumb>
  <div [class.container-fluid]="!embedded">

    <!-- KPI strip -->
    <div class="row g-3 mb-3" *ngIf="!embedded && summary">
      <div class="col-6 col-md-3">
        <div class="kpi">
          <div class="kpi-label">Due today</div>
          <div class="kpi-value">{{ summary.due_today }}</div>
        </div>
      </div>
      <div class="col-6 col-md-3">
        <div class="kpi">
          <div class="kpi-label">Overdue</div>
          <div class="kpi-value" [class.text-danger]="summary.overdue > 0">{{ summary.overdue }}</div>
        </div>
      </div>
      <div class="col-6 col-md-3">
        <div class="kpi">
          <div class="kpi-label">In progress now</div>
          <div class="kpi-value">{{ summary.in_progress }}</div>
        </div>
      </div>
      <div class="col-6 col-md-3">
        <div class="kpi">
          <div class="kpi-label">Done this week</div>
          <div class="kpi-value text-success">{{ summary.done_this_week }}</div>
        </div>
      </div>
    </div>

    <div class="card" [class.mb-0]="embedded">
      <div class="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
        <div class="d-flex align-items-center gap-3">
          <h4 class="card-title mb-0">{{ embedded ? 'Tasks' : 'Team Tasks' }}</h4>
          <div class="btn-group btn-group-sm" role="group" *ngIf="!embedded">
            <button type="button" class="btn" [ngClass]="view === 'list' ? 'btn-primary' : 'btn-outline-primary'"
              (click)="setView('list')">List</button>
            <button type="button" class="btn" [ngClass]="view === 'board' ? 'btn-primary' : 'btn-outline-primary'"
              (click)="setView('board')">Board</button>
          </div>
        </div>
        <button *ngIf="canAdd" class="btn btn-primary btn-sm" (click)="openTaskModal()"
          [disabled]="loadingService.isLoading()">
          <i class="bi bi-plus-circle me-1"></i> {{ embedded ? 'Task' : 'Create Task' }}
        </button>
      </div>

      <div class="card-body">
        <!-- Filters -->
        <form [formGroup]="searchForm">
          <div class="row g-2 mb-3 align-items-end">
            <div [ngClass]="embedded ? 'col-md-5' : 'col-xl-2 col-md-4'">
              <label class="form-label">Search</label>
              <input type="text" class="form-control input-default search-textbox-height" formControlName="search"
                placeholder="Title, task id..." />
            </div>
            <div class="col-xl-2 col-md-4" *ngIf="!embedded">
              <label class="form-label">Assignee</label>
              <ng-select [items]="assignees.items" bindValue="value" bindLabel="label" placeholder="All staff"
                class="select2 select2-sm" formControlName="assignee_id" [typeahead]="assignees.search$"
                [virtualScroll]="true" (scrollToEnd)="assignees.scrollEnd()" (change)="handleSearch(''); getSummary()">
              </ng-select>
            </div>
            <div class="col-xl-2 col-md-4" *ngIf="!embedded && !propertyId">
              <label class="form-label">Property</label>
              <ng-select [items]="properties.items" bindValue="value" bindLabel="label" placeholder="All properties"
                class="select2 select2-sm" formControlName="property_id" [typeahead]="properties.search$"
                [virtualScroll]="true" (scrollToEnd)="properties.scrollEnd()" (change)="handleSearch('')">
              </ng-select>
            </div>
            <div class="col-xl-2 col-md-4" *ngIf="!embedded">
              <label class="form-label">Type</label>
              <ng-select [items]="typeOptions" bindValue="value" bindLabel="label" placeholder="All types"
                class="select2 select2-sm" formControlName="task_type" (change)="handleSearch('')"></ng-select>
            </div>
            <div [ngClass]="embedded ? 'col-md-4' : 'col-xl-2 col-md-4'" *ngIf="view === 'list'">
              <label class="form-label">Status</label>
              <select class="form-select input-default search-textbox-height" formControlName="status"
                (change)="handleSearch('')">
                <option value="open">Open</option>
                <option value="">All statuses</option>
                <option *ngFor="let option of statusOptions" [value]="option.value">{{ option.label }}</option>
              </select>
            </div>
            <div class="col-xl-2 col-md-4" *ngIf="!embedded">
              <label class="form-label">Due</label>
              <select class="form-select input-default search-textbox-height" formControlName="due"
                (change)="onDueChange()">
                <option *ngFor="let option of dueOptions" [value]="option.value">{{ option.label }}</option>
              </select>
            </div>
            <ng-container *ngIf="!embedded && searchForm.value.due === 'range'">
              <div class="col-xl-2 col-md-4">
                <label class="form-label">From</label>
                <input type="date" class="form-control input-default search-textbox-height" formControlName="due_from"
                  (change)="handleSearch('')" />
              </div>
              <div class="col-xl-2 col-md-4">
                <label class="form-label">To</label>
                <input type="date" class="form-control input-default search-textbox-height" formControlName="due_to"
                  [min]="searchForm.value.due_from" (change)="handleSearch('')" />
              </div>
            </ng-container>
            <div class="col-xl-2 col-md-4" *ngIf="!embedded">
              <label class="form-label">Priority</label>
              <select class="form-select input-default search-textbox-height" formControlName="priority"
                (change)="handleSearch('')">
                <option value="">All priorities</option>
                <option *ngFor="let option of priorityOptions" [value]="option.value">{{ option.label }}</option>
              </select>
            </div>
            <div [ngClass]="embedded ? 'col-md-3' : 'col-xl-2 col-md-4'">
              <button type="button" class="btn btn-secondary btn-sm" (click)="resetSearchForm()"
                [disabled]="!disableClear || loadingService.isLoading()">Clear</button>
            </div>
          </div>
        </form>

        <!-- ───────────── LIST VIEW ───────────── -->
        <ng-container *ngIf="view === 'list'">
          <div class="table-responsive">
            <table class="table table-hover align-middle" matSort (matSortChange)="sortData($event)">
              <thead>
                <tr>
                  <th mat-sort-header="title">Task</th>
                  <th mat-sort-header="task_type">Type</th>
                  <th *ngIf="!propertyId && !relatedId">Linked to</th>
                  <th>Assignee</th>
                  <th mat-sort-header="due_date">Due</th>
                  <th mat-sort-header="priority">Priority</th>
                  <th mat-sort-header="status">Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="loadingService.isLoading()">
                  <td colspan="8" class="text-center py-4">
                    <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div>
                  </td>
                </tr>
                <tr *ngIf="!loadingService.isLoading() && tasks.length === 0">
                  <td colspan="8" class="text-center py-4">No tasks found</td>
                </tr>
                <tr *ngFor="let task of tasks">
                  <td>
                    <span class="task-id-link me-1" (click)="viewTask(task.id)">{{ task.task_id }}</span>
                    <span class="task-name-link" (click)="viewTask(task.id)">{{ task.title }}</span>
                    <div class="subline">
                      <span *ngIf="task.created_by">Created by {{ task.created_by }}</span>
                      <span *ngIf="attachmentCount(task) > 0"> · {{ attachmentCount(task) }} attachment{{ attachmentCount(task) > 1 ? 's' : '' }}</span>
                      <span *ngIf="task.checklist?.total"> · Checklist {{ task.checklist?.done }}/{{ task.checklist?.total }}</span>
                      <span *ngIf="task.recurrence_id"> · Recurring</span>
                    </div>
                  </td>
                  <td>{{ task.task_type || task.category || '-' }}</td>
                  <td *ngIf="!propertyId && !relatedId">
                    <ng-container *ngIf="linkedName(task); else noLink">
                      <a *ngIf="task.property" [routerLink]="['/admin/properties/property-view', task.property.id, 1]">{{ task.property.name }}</a>
                      <a *ngIf="!task.property && task.related?.type === 'lead'" [routerLink]="['/admin/leads/view', task.related?.id]">{{ task.related?.name }}</a>
                      <span *ngIf="!task.property && task.related?.type !== 'lead'">{{ task.related?.name }}</span>
                      <div class="subline">{{ linkedSubline(task) }}</div>
                    </ng-container>
                    <ng-template #noLink>—</ng-template>
                  </td>
                  <td>
                    <div class="d-flex align-items-center gap-2" *ngIf="task.assignee || task.owner; else noAssignee">
                      <span class="avatar">{{ initials((task.assignee || task.owner)?.name) }}</span>
                      <span>{{ (task.assignee || task.owner)?.name }}</span>
                    </div>
                    <ng-template #noAssignee>—</ng-template>
                  </td>
                  <td>
                    <span *ngIf="task.is_overdue" class="badge bg-danger me-1">Overdue {{ overdueDays(task) }}d</span>
                    <span *ngIf="task.due_date">{{ task.due_date | date: 'EEE d MMM' }}</span>
                    <span *ngIf="!task.due_date">—</span>
                    <div class="subline" *ngIf="plannedWindow(task)">{{ plannedWindow(task) }}</div>
                  </td>
                  <td><span class="badge" [ngClass]="priorityClass(task.priority)">{{ task.priority }}</span></td>
                  <td>
                    <span class="badge" [ngClass]="statusClass(task.status)">{{ task.status }}</span>
                    <span *ngIf="task.verified_at" class="badge bg-info ms-1">Verified</span>
                  </td>
                  <td>
                    <div class="d-flex">
                      <button class="btn btn-primary shadow btn-xs sharp me-1" (click)="viewTask(task.id)" title="View Task">
                        <i class="fa fa-eye"></i>
                      </button>
                      <button *ngIf="canUpdate" class="btn btn-info shadow btn-xs sharp me-1" (click)="openTaskModal(task.id)" title="Edit Task">
                        <i class="fa fa-pencil"></i>
                      </button>
                      <button *ngIf="canDelete" class="btn btn-danger shadow btn-xs sharp me-1" (click)="deleteTask(task.id)" title="Delete Task">
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="d-flex justify-content-between align-items-center mt-3">
            <div class="dataTables_info">
              Showing {{ totalTasks ? (page - 1) * limit + 1 : 0 }} to {{ (page - 1) * limit + totalRows }} of {{ totalTasks }} entries
            </div>
            <app-pagination [page]="page" [totalPage]="totalPage" (newPage)="pageChange($event)"></app-pagination>
          </div>
        </ng-container>

        <!-- ───────────── BOARD VIEW ───────────── -->
        <div class="board" *ngIf="view === 'board'" cdkDropListGroup>
          <div class="lane" *ngFor="let lane of lanes">
            <div class="lane-header">
              <span>{{ lane.status }}</span>
              <span class="text-muted">{{ lane.tasks.length }}</span>
            </div>
            <div class="lane-list" cdkDropList [id]="laneId(lane)" [cdkDropListData]="lane.tasks"
              [cdkDropListDisabled]="!canUpdate" (cdkDropListDropped)="onDrop($event, lane)">
              <div class="task-card" [class.overdue]="task.is_overdue" *ngFor="let task of lane.tasks" cdkDrag
                [cdkDragDisabled]="!canUpdate">
                <div class="card-title c-pointer" (click)="viewTask(task.id)">{{ task.title }}</div>
                <div class="d-flex flex-wrap gap-1">
                  <span *ngIf="task.is_overdue" class="badge bg-danger">Overdue {{ overdueDays(task) }}d</span>
                  <span *ngIf="!task.is_overdue && task.due_date" class="badge bg-light text-dark">{{ task.due_date | date: 'd MMM' }}</span>
                  <span class="badge" [ngClass]="priorityClass(task.priority)">{{ task.priority }}</span>
                  <span *ngIf="task.verified_at" class="badge bg-info">Verified</span>
                </div>
                <div class="subline mt-1" *ngIf="task.status === 'On Hold' && task.hold_reason">{{ task.hold_reason }}</div>
                <div class="card-foot">
                  <span class="subline text-truncate">{{ linkedName(task) || task.task_type || task.task_id }}</span>
                  <span class="avatar" *ngIf="task.assignee || task.owner" [title]="(task.assignee || task.owner)?.name">
                    {{ initials((task.assignee || task.owner)?.name) }}
                  </span>
                </div>
              </div>
              <div class="text-center text-muted small py-3" *ngIf="lane.tasks.length === 0">No tasks</div>
            </div>
          </div>
        </div>
        <small class="text-muted" *ngIf="view === 'board' && canUpdate">Drag a card to another lane to change its status.</small>
      </div>
    </div>
  </div>
</div>

<!-- Create / edit offcanvas -->
<app-task-form #taskForm [prefill]="prefill" (saved)="reload()"></app-task-form>

<!-- Hold reason prompt -->
<ng-template #holdReasonModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Put task on hold</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <label class="form-label">Reason <span class="text-danger">*</span></label>
    <textarea class="form-control" rows="3" [(ngModel)]="holdReason" placeholder="Why is this task on hold?"></textarea>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-sm" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-primary btn-sm" [disabled]="!holdReason.trim()" (click)="modal.close(holdReason)">Put on hold</button>
  </div>
</ng-template>
